import type { IconProps } from '../../types/icon-props';

export const NoComment = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_2017_26077)">
        <path
          d="M5.51562 14.1328H115.508C118.273 14.1328 120.523 16.3828 120.523 19.1484V83.4141C120.523 86.1797 118.273 88.4297 115.508 88.4297H5.51562C2.75 88.4297 0.5 86.1797 0.5 83.4141V19.1484C0.5 16.3828 2.75 14.1328 5.51562 14.1328Z"
          fill="url(#paint0_linear_2017_26077)"
        />
        <path
          d="M0.921875 17.1562C0.640625 17.7656 0.5 18.4453 0.5 19.1484V83.4141C0.5 86.1797 2.75 88.4297 5.51562 88.4297H52.5312V17.1562H0.921875Z"
          fill="url(#paint1_linear_2017_26077)"
        />
        <path
          d="M55.4609 57.3516L86.5391 88.4297H115.508C118.273 88.4297 120.523 86.1797 120.523 83.4141V19.1484C120.523 18.4687 120.383 17.7891 120.125 17.2031L55.4609 57.3516Z"
          fill="url(#paint2_linear_2017_26077)"
        />
        <path
          d="M115.484 88.4297H5.51562C3.45312 88.4297 1.69531 87.1875 0.921875 85.4062L55.4609 45.2109C58.4609 43.0078 62.5625 43.0078 65.5625 45.2109L120.102 85.4062C119.328 87.1875 117.547 88.4297 115.484 88.4297Z"
          fill="url(#paint3_linear_2017_26077)"
        />
        <path
          d="M0.5 46.4531V83.4375C0.5 86.2031 2.75 88.4531 5.51562 88.4531H115.508C118.273 88.4531 120.523 86.2031 120.523 83.4375V46.4531H0.5Z"
          fill="url(#paint4_linear_2017_26077)"
        />
        <path
          d="M115.484 14.1328H67.8594V88.4063H115.508C118.273 88.4063 120.523 86.1562 120.523 83.3906V19.1484C120.5 16.3828 118.25 14.1328 115.484 14.1328Z"
          fill="url(#paint5_linear_2017_26077)"
        />
        <path
          d="M55.4609 57.3516L86.5391 88.4297H115.508C118.273 88.4297 120.523 86.1797 120.523 83.4141V19.1484C120.523 18.4687 120.383 17.7891 120.125 17.2031L55.4609 57.3516Z"
          fill="url(#paint6_linear_2017_26077)"
        />
        <path
          d="M115.484 14.1328H5.51562C3.45312 14.1328 1.69531 15.375 0.921875 17.1562L55.4609 57.3516C58.4609 59.5547 62.5625 59.5547 65.5625 57.3516L120.078 17.1562C119.328 15.375 117.547 14.1328 115.484 14.1328Z"
          fill="url(#paint7_linear_2017_26077)"
        />
        <path
          d="M115.484 14.1328H5.51562C3.45312 14.1328 1.69531 15.375 0.921875 17.1562L55.4609 57.3516C58.4609 59.5547 62.5625 59.5547 65.5625 57.3516L120.078 17.1562C119.328 15.375 117.547 14.1328 115.484 14.1328Z"
          fill="url(#paint8_linear_2017_26077)"
        />
        <path d="M49.7891 81L57.2187 88.4297H69.9922L49.7891 81Z" fill="url(#paint9_linear_2017_26077)" />
        <path
          d="M115.484 88.4297C118.25 88.4297 120.5 86.1797 120.5 83.4141V42.0469L112.438 33.9844L106.742 39.6797V88.4063H115.484V88.4297Z"
          fill="url(#paint10_linear_2017_26077)"
        />
        <path
          d="M75.6172 91.0547V103.969C75.6172 105.656 77.6562 106.5 78.8516 105.305L90.3125 93.8437L75.6172 91.0547Z"
          fill="url(#paint11_linear_2017_26077)"
        />
        <path
          d="M75.6172 91.0547V103.969C75.6172 105.656 77.6562 106.5 78.8516 105.305L90.3125 93.8437L75.6172 91.0547Z"
          fill="url(#paint12_linear_2017_26077)"
        />
        <path
          d="M75.6172 91.0547V103.969C75.6172 105.656 77.6562 106.5 78.8516 105.305L90.3125 93.8437L75.6172 91.0547Z"
          fill="url(#paint13_linear_2017_26077)"
        />
        <path
          d="M50.3984 81.3516L107.305 103.242C108.734 103.781 110.281 102.773 110.328 101.25L112.883 35.4375C112.953 33.5625 110.82 32.4375 109.32 33.5625L49.8593 77.4609C48.4531 78.5156 48.7343 80.7188 50.3984 81.3516Z"
          fill="url(#paint14_linear_2017_26077)"
        />
        <path
          d="M77.4472 57.0938L49.8847 77.4609C48.4784 78.5156 48.7597 80.7188 50.4003 81.3516L107.307 103.242C108.736 103.781 110.283 102.773 110.33 101.25L111.525 70.7578L77.4472 57.0938Z"
          fill="url(#paint15_linear_2017_26077)"
        />
        <path
          d="M111.523 33.2813L75.6171 91.0547L50.3984 81.3516C48.7577 80.7188 48.453 78.5157 49.8827 77.4844L109.344 33.5625C110.023 33.0235 110.844 33 111.523 33.2813Z"
          fill="url(#paint16_linear_2017_26077)"
        />
        <path
          d="M111.523 33.2812L75.6172 91.0547L107.305 103.242C108.734 103.805 110.281 102.773 110.328 101.25L112.883 35.4375C112.93 34.4062 112.32 33.6094 111.523 33.2812Z"
          fill="url(#paint17_linear_2017_26077)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2017_26077"
          x1="52.0794"
          y1="27.5667"
          x2="75.3005"
          y2="92.9653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEF0AE" />
          <stop offset="1" stop-color="#FAC600" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2017_26077"
          x1="27.7278"
          y1="51.7704"
          x2="40.5369"
          y2="38.7368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE9738" stop-opacity="0" />
          <stop offset="0.102" stop-color="#FE9738" stop-opacity="0.02" />
          <stop offset="0.227" stop-color="#FE9738" stop-opacity="0.078" />
          <stop offset="0.361" stop-color="#FE9738" stop-opacity="0.175" />
          <stop offset="0.505" stop-color="#FE9738" stop-opacity="0.31" />
          <stop offset="0.654" stop-color="#FE9738" stop-opacity="0.483" />
          <stop offset="0.808" stop-color="#FE9738" stop-opacity="0.695" />
          <stop offset="0.965" stop-color="#FE9738" stop-opacity="0.94" />
          <stop offset="1" stop-color="#FE9738" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2017_26077"
          x1="97.9154"
          y1="54.9729"
          x2="89.6007"
          y2="68.4562"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE9738" stop-opacity="0" />
          <stop offset="0.102" stop-color="#FE9738" stop-opacity="0.02" />
          <stop offset="0.227" stop-color="#FE9738" stop-opacity="0.078" />
          <stop offset="0.361" stop-color="#FE9738" stop-opacity="0.175" />
          <stop offset="0.505" stop-color="#FE9738" stop-opacity="0.31" />
          <stop offset="0.654" stop-color="#FE9738" stop-opacity="0.483" />
          <stop offset="0.808" stop-color="#FE9738" stop-opacity="0.695" />
          <stop offset="0.965" stop-color="#FE9738" stop-opacity="0.94" />
          <stop offset="1" stop-color="#FE9738" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2017_26077"
          x1="50.2845"
          y1="56.7049"
          x2="64.4417"
          y2="96.4802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEF0AE" />
          <stop offset="1" stop-color="#FAC600" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2017_26077"
          x1="60.5"
          y1="79.2098"
          x2="60.5"
          y2="87.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE9738" stop-opacity="0" />
          <stop offset="0.102" stop-color="#FE9738" stop-opacity="0.02" />
          <stop offset="0.227" stop-color="#FE9738" stop-opacity="0.078" />
          <stop offset="0.361" stop-color="#FE9738" stop-opacity="0.175" />
          <stop offset="0.505" stop-color="#FE9738" stop-opacity="0.31" />
          <stop offset="0.654" stop-color="#FE9738" stop-opacity="0.483" />
          <stop offset="0.808" stop-color="#FE9738" stop-opacity="0.695" />
          <stop offset="0.965" stop-color="#FE9738" stop-opacity="0.94" />
          <stop offset="1" stop-color="#FE9738" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2017_26077"
          x1="112.794"
          y1="51.282"
          x2="120.884"
          y2="51.282"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE9738" stop-opacity="0" />
          <stop offset="0.102" stop-color="#FE9738" stop-opacity="0.02" />
          <stop offset="0.227" stop-color="#FE9738" stop-opacity="0.078" />
          <stop offset="0.361" stop-color="#FE9738" stop-opacity="0.175" />
          <stop offset="0.505" stop-color="#FE9738" stop-opacity="0.31" />
          <stop offset="0.654" stop-color="#FE9738" stop-opacity="0.483" />
          <stop offset="0.808" stop-color="#FE9738" stop-opacity="0.695" />
          <stop offset="0.965" stop-color="#FE9738" stop-opacity="0.94" />
          <stop offset="1" stop-color="#FE9738" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2017_26077"
          x1="97.2453"
          y1="51.1406"
          x2="87.5825"
          y2="36.9834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE9738" stop-opacity="0" />
          <stop offset="0.102" stop-color="#FE9738" stop-opacity="0.02" />
          <stop offset="0.227" stop-color="#FE9738" stop-opacity="0.078" />
          <stop offset="0.361" stop-color="#FE9738" stop-opacity="0.175" />
          <stop offset="0.505" stop-color="#FE9738" stop-opacity="0.31" />
          <stop offset="0.654" stop-color="#FE9738" stop-opacity="0.483" />
          <stop offset="0.808" stop-color="#FE9738" stop-opacity="0.695" />
          <stop offset="0.965" stop-color="#FE9738" stop-opacity="0.94" />
          <stop offset="1" stop-color="#FE9738" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2017_26077"
          x1="61.2734"
          y1="19.3111"
          x2="73.7455"
          y2="54.0305"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEF0AE" />
          <stop offset="1" stop-color="#FAC600" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2017_26077"
          x1="74.9888"
          y1="41.8378"
          x2="79.6191"
          y2="49.7367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEF0AE" stop-opacity="0" />
          <stop offset="0.1" stop-color="#FEF0AE" stop-opacity="0.021" />
          <stop offset="0.224" stop-color="#FEF0AE" stop-opacity="0.081" />
          <stop offset="0.361" stop-color="#FEF0AE" stop-opacity="0.181" />
          <stop offset="0.507" stop-color="#FEF0AE" stop-opacity="0.32" />
          <stop offset="0.66" stop-color="#FEF0AE" stop-opacity="0.498" />
          <stop offset="0.82" stop-color="#FEF0AE" stop-opacity="0.717" />
          <stop offset="0.982" stop-color="#FEF0AE" stop-opacity="0.97" />
          <stop offset="1" stop-color="#FEF0AE" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2017_26077"
          x1="58.3883"
          y1="90.7036"
          x2="60.0226"
          y2="84.2177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE9738" stop-opacity="0" />
          <stop offset="0.102" stop-color="#FE9738" stop-opacity="0.02" />
          <stop offset="0.227" stop-color="#FE9738" stop-opacity="0.078" />
          <stop offset="0.361" stop-color="#FE9738" stop-opacity="0.175" />
          <stop offset="0.505" stop-color="#FE9738" stop-opacity="0.31" />
          <stop offset="0.654" stop-color="#FE9738" stop-opacity="0.483" />
          <stop offset="0.808" stop-color="#FE9738" stop-opacity="0.695" />
          <stop offset="0.965" stop-color="#FE9738" stop-opacity="0.94" />
          <stop offset="1" stop-color="#FE9738" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2017_26077"
          x1="121.32"
          y1="62.4642"
          x2="109.88"
          y2="61.2384"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE9738" stop-opacity="0" />
          <stop offset="0.102" stop-color="#FE9738" stop-opacity="0.02" />
          <stop offset="0.227" stop-color="#FE9738" stop-opacity="0.078" />
          <stop offset="0.361" stop-color="#FE9738" stop-opacity="0.175" />
          <stop offset="0.505" stop-color="#FE9738" stop-opacity="0.31" />
          <stop offset="0.654" stop-color="#FE9738" stop-opacity="0.483" />
          <stop offset="0.808" stop-color="#FE9738" stop-opacity="0.695" />
          <stop offset="0.965" stop-color="#FE9738" stop-opacity="0.94" />
          <stop offset="1" stop-color="#FE9738" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2017_26077"
          x1="75.5347"
          y1="92.2685"
          x2="84.8921"
          y2="101.158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C8EFFE" />
          <stop offset="0.103" stop-color="#C0EDFD" />
          <stop offset="0.258" stop-color="#ABEAFD" />
          <stop offset="0.447" stop-color="#89E5FD" />
          <stop offset="0.661" stop-color="#5ADDFC" />
          <stop offset="0.895" stop-color="#1ED4FB" />
          <stop offset="1" stop-color="#01D0FB" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2017_26077"
          x1="79.3119"
          y1="100.727"
          x2="82.7037"
          y2="93.0068"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0290CF" stop-opacity="0" />
          <stop offset="0.219" stop-color="#0290CF" stop-opacity="0.013" />
          <stop offset="0.364" stop-color="#0290CF" stop-opacity="0.056" />
          <stop offset="0.487" stop-color="#0290CF" stop-opacity="0.128" />
          <stop offset="0.599" stop-color="#0290CF" stop-opacity="0.231" />
          <stop offset="0.702" stop-color="#0290CF" stop-opacity="0.364" />
          <stop offset="0.799" stop-color="#0290CF" stop-opacity="0.528" />
          <stop offset="0.892" stop-color="#0290CF" stop-opacity="0.722" />
          <stop offset="0.979" stop-color="#0290CF" stop-opacity="0.941" />
          <stop offset="1" stop-color="#0290CF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2017_26077"
          x1="75.8867"
          y1="95.6381"
          x2="85.595"
          y2="100.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0290CF" stop-opacity="0" />
          <stop offset="0.219" stop-color="#0290CF" stop-opacity="0.013" />
          <stop offset="0.364" stop-color="#0290CF" stop-opacity="0.056" />
          <stop offset="0.487" stop-color="#0290CF" stop-opacity="0.128" />
          <stop offset="0.599" stop-color="#0290CF" stop-opacity="0.231" />
          <stop offset="0.702" stop-color="#0290CF" stop-opacity="0.364" />
          <stop offset="0.799" stop-color="#0290CF" stop-opacity="0.528" />
          <stop offset="0.892" stop-color="#0290CF" stop-opacity="0.722" />
          <stop offset="0.979" stop-color="#0290CF" stop-opacity="0.941" />
          <stop offset="1" stop-color="#0290CF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2017_26077"
          x1="77.0555"
          y1="53.4302"
          x2="107.112"
          y2="83.4865"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C8EFFE" />
          <stop offset="0.103" stop-color="#C0EDFD" />
          <stop offset="0.258" stop-color="#ABEAFD" />
          <stop offset="0.447" stop-color="#89E5FD" />
          <stop offset="0.661" stop-color="#5ADDFC" />
          <stop offset="0.895" stop-color="#1ED4FB" />
          <stop offset="1" stop-color="#01D0FB" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2017_26077"
          x1="80.9307"
          y1="86.4333"
          x2="78.7084"
          y2="92.9836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0290CF" stop-opacity="0" />
          <stop offset="0.219" stop-color="#0290CF" stop-opacity="0.013" />
          <stop offset="0.364" stop-color="#0290CF" stop-opacity="0.056" />
          <stop offset="0.487" stop-color="#0290CF" stop-opacity="0.128" />
          <stop offset="0.599" stop-color="#0290CF" stop-opacity="0.231" />
          <stop offset="0.702" stop-color="#0290CF" stop-opacity="0.364" />
          <stop offset="0.799" stop-color="#0290CF" stop-opacity="0.528" />
          <stop offset="0.892" stop-color="#0290CF" stop-opacity="0.722" />
          <stop offset="0.979" stop-color="#0290CF" stop-opacity="0.941" />
          <stop offset="1" stop-color="#0290CF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_2017_26077"
          x1="86.262"
          y1="60.9774"
          x2="93.2798"
          y2="65.7732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0290CF" stop-opacity="0" />
          <stop offset="0.219" stop-color="#0290CF" stop-opacity="0.013" />
          <stop offset="0.364" stop-color="#0290CF" stop-opacity="0.056" />
          <stop offset="0.487" stop-color="#0290CF" stop-opacity="0.128" />
          <stop offset="0.599" stop-color="#0290CF" stop-opacity="0.231" />
          <stop offset="0.702" stop-color="#0290CF" stop-opacity="0.364" />
          <stop offset="0.799" stop-color="#0290CF" stop-opacity="0.528" />
          <stop offset="0.892" stop-color="#0290CF" stop-opacity="0.722" />
          <stop offset="0.979" stop-color="#0290CF" stop-opacity="0.941" />
          <stop offset="1" stop-color="#0290CF" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_2017_26077"
          x1="105.959"
          y1="67.984"
          x2="112.275"
          y2="68.5687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0290CF" stop-opacity="0" />
          <stop offset="0.219" stop-color="#0290CF" stop-opacity="0.013" />
          <stop offset="0.364" stop-color="#0290CF" stop-opacity="0.056" />
          <stop offset="0.487" stop-color="#0290CF" stop-opacity="0.128" />
          <stop offset="0.599" stop-color="#0290CF" stop-opacity="0.231" />
          <stop offset="0.702" stop-color="#0290CF" stop-opacity="0.364" />
          <stop offset="0.799" stop-color="#0290CF" stop-opacity="0.528" />
          <stop offset="0.892" stop-color="#0290CF" stop-opacity="0.722" />
          <stop offset="0.979" stop-color="#0290CF" stop-opacity="0.941" />
          <stop offset="1" stop-color="#0290CF" />
        </linearGradient>
        <clipPath id="clip0_2017_26077">
          <rect width="120" height="120" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

NoComment.displayName = 'NoComment';
